import { decodeLocationSlug } from './decode-location-slug';
import { isKnownFinlandPlaceName } from '../geocoding/finland-place-names';
import { getFinlandTownLabels } from '../facets/region-tag-labels';

const FINLAND_COUNTRY_WORDS = new Set(['finland', 'suomi']);

/**
 * True when a `/jobs/location/:slug` segment names a real Finnish place (per the GeoNames
 * gazetteer, ~910 places) with a Finland country suffix: `laitila_suomi`, `hyvink%C3%A4%C3%A4_suomi`,
 * `Tuusula_Finland`. Nonsense (`atlantis_narnia`), wrong-country combos (`torrevieja_finland`)
 * and foreign cities (`malm%C3%B6_ruotsi`) all return false.
 *
 * Used by pages/index/+data.ts to decide whether a location page goes through the normal robots
 * rules or is forced to noindex. It says nothing about HTTP status: the location route always
 * renders a 200, and it says nothing about job counts either, which is the robots layer's job
 * (computeSrpRobotsContent / getRobotsDirective's minimum-count rule).
 */
export function isGazetteerFinnishTownSlug(rawSlug: string | null | undefined): boolean {
  if (!rawSlug) return false;
  const decoded = decodeLocationSlug(rawSlug);
  const commaIdx = decoded.lastIndexOf(',');
  if (commaIdx <= 0) return false;
  const town = decoded.slice(0, commaIdx).trim();
  const country = decoded.slice(commaIdx + 1).trim().toLowerCase();
  if (!town || !FINLAND_COUNTRY_WORDS.has(country)) return false;
  // The region-tag labels as a fallback: they carry the Swedish names our sv URLs are built from
  // (kuhmois_finland, ruokolax_finland, vederlax_finland) that the GeoNames names list lacks.
  return isKnownFinlandPlaceName(town) || getFinlandTownLabels(town) !== undefined;
}
